module.exports = __webpack_public_path__ + "static/img/initiative4.835d3f8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/product/initiative4.png
// module id = lhTM
// module chunks = 1